import { useContext } from "react";
import { ComponentListPageContext, PageNewState } from "./";

export const usePageState = () => {
  const { pageState, setPageState } = useContext(ComponentListPageContext);
  return [
    pageState,
    (newState: PageNewState) => setPageState(newState),
  ] as const;
};
